<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>餐廳基本設定</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="reset">
          <font-awesome-icon icon="undo-alt"/>
        </f7-link>
        <f7-link @click="save">
          <font-awesome-icon :icon="['far', 'save']" :class="{ dirty }" />
        </f7-link>
      </f7-nav-right>
    </f7-navbar>

    <div style="position: absolute; top: 56px; bottom: 0px; left: 0px; right: 0px; overflow: auto; margin: 5px 0px 30px;">
      <f7-list v-if="storeData">
        <f7-list-item :title="`店家 ID: ${storeData.id}`" />
        <f7-list-item title="* 為必填" style="color: red;" />

        <f7-list-item title="基本資料" group-title />
        <f7-list-item ref="name">
          <f7-label :style="requiredStyle('name')">餐廳名稱 *</f7-label>
          <f7-input type="text" placeholder="公開顯示在網頁上" :value="storeData.name" @input="setEditorStoreData('name', $event.target.value)" @focus="onFocus('name')" clear-button />
        </f7-list-item>
        <f7-list-item ref="branch">
          <f7-label>分店名稱</f7-label>
          <f7-input type="text" placeholder="若是只有一間分店則空白" :value="storeData.branch" @input="setEditorStoreData('branch', $event.target.value)" @focus="onFocus('branch')" clear-button />
        </f7-list-item>
        <f7-list-item ref="companyName">
          <f7-label>餐廳商業登記名稱</f7-label>
          <f7-input type="text" placeholder="本欄用於正式資訊" :value="storeData.companyName" @input="setEditorStoreData('companyName', $event.target.value)" @focus="onFocus('companyName')" clear-button />
        </f7-list-item>
        <f7-list-item ref="registeredOwner">
          <f7-label :style="requiredStyle('registeredOwner')">餐廳登記負責人姓名 *</f7-label>
          <f7-input type="text" placeholder="本欄用於正式資訊" :value="storeData.registeredOwner" @input="setEditorStoreData('registeredOwner', $event.target.value)" @focus="onFocus('registeredOwner')" clear-button />
        </f7-list-item>
        <f7-list-item ref="storePhoneNumber">
          <f7-label>店家電話 (顯示於點餐網頁)</f7-label>
          <f7-input type="text" placeholder="ex. (02) 2912-3456" :value="storeData.storePhoneNumber" @input="setEditorStoreData('storePhoneNumber', $event.target.value)" @focus="onFocus('storePhoneNumber')" clear-button />
        </f7-list-item>
        <f7-list-item ref="phoneNumber">
          <f7-label :style="requiredStyle('phoneNumber')">負責人手機號碼 (緊急聯絡) *</f7-label>
          <f7-input type="text" placeholder="ex. 0912-345-678" :value="storeData.phoneNumber" @input="setEditorStoreData('phoneNumber', $event.target.value)" @focus="onFocus('phoneNumber')" clear-button />
        </f7-list-item>
        <f7-list-item ref="email">
          <f7-label :style="requiredStyle('email')">聯絡人 Email *</f7-label>
          <f7-input type="text" placeholder="聯絡方式" :value="storeData.email" @input="setEditorStoreData('email', $event.target.value)" @focus="onFocus('email')" clear-button />
        </f7-list-item>
        <f7-list-item ref="taxId">
          <f7-label>餐廳統一編號</f7-label>
          <f7-input type="text" placeholder="ex. 12345678" :value="storeData.taxId" @input="setEditorStoreData('taxId', $event.target.value)" @focus="onFocus('taxId')" clear-button />
        </f7-list-item>
        <f7-list-item ref="address">
          <f7-label>餐廳地址</f7-label>
          <f7-input type="text" placeholder="顯示於網頁上" :value="storeData.address" @input="setEditorStoreData('address', $event.target.value)" @focus="onFocus('address')" clear-button />
        </f7-list-item>
        <f7-list-item ref='description'>
          <f7-label>關於商家(營業時間 &amp; 餐廳特色)</f7-label>
          <f7-input type="textarea" resizable :value="storeData.description" @input="setEditorStoreData('description', $event.target.value)" @focus="onFocus('description')" />
        </f7-list-item>
        <f7-list-item checkbox title="顯示公告" :checked="storeData.showAnnouncement" @change="setEditorStoreData('showAnnouncement', $event.target.checked)" />
        <f7-list-item ref='announcement'>
          <f7-label>公告內容</f7-label>
          <f7-input type="textarea" resizable :value="storeData.announcement" @input="setEditorStoreData('announcement', $event.target.value)" @focus="onFocus('announcement')" />
        </f7-list-item>
        <f7-list-item title="廚房設定" group-title />
        <f7-list-item checkbox title="餐點一起畫線" @change="setEditorStoreData('touchStateGrouped', $event.target.checked)" :checked="storeData.touchStateGrouped"></f7-list-item>

        <f7-list-item title="進階設定" group-title />
        <f7-list-item ref="preOrderDisplayBoundaryMinutes">
          <f7-label :style="requiredStyle('preOrderDisplayBoundaryMinutes')">預約外帶幾分鐘之前將跳出提醒</f7-label>
          <f7-input type="number" placeholder="建議 10 分鐘" :value="storeData.preOrderDisplayBoundaryMinutes" @input="setEditorStoreData('preOrderDisplayBoundaryMinutes', parseInt($event.target.value))" @focus="onFocus('preOrderDisplayBoundaryMinutes')" clear-button />
        </f7-list-item>
        <f7-list-item ref="preOrderLatestOrderBoundaryMinutes">
          <f7-label :style="requiredStyle('preOrderLatestOrderBoundaryMinutes')">預約外帶最早接受距離現在幾分鐘之後的單 (建議 30 分鐘)</f7-label>
          <f7-input type="number" placeholder="建議 30 分鐘" :value="storeData.preOrderLatestOrderBoundaryMinutes" @input="setEditorStoreData('preOrderLatestOrderBoundaryMinutes', parseInt($event.target.value))" @focus="onFocus('preOrderLatestOrderBoundaryMinutes')" clear-button />
        </f7-list-item>
        <f7-list-item ref="serviceCharge">
          <f7-label>服務費 (%)</f7-label>
          <f7-input type="number" placeholder="ex. 10" :value="storeData.serviceCharge" @input="setEditorStoreData('serviceCharge', parseFloat($event.target.value || 0))" @focus="onFocus('serviceCharge')" @blur="onServiceChargeBlur" clear-button />
        </f7-list-item>
        <f7-list-item checkbox title="內用外帶訂單必須先付款" :checked="storeData.payFirst" @change="setEditorStoreData('payFirst', $event.target.checked)" />
        <f7-list-item checkbox title="接受預約外帶" :checked="storeData.isSupportTakeout" @change="setEditorStoreData('isSupportTakeout', $event.target.checked)" />
        <f7-list-item checkbox title="預約外帶訂單必須先付款" :checked="storeData.shouldPreOrderPrePaid" @change="setEditorStoreData('shouldPreOrderPrePaid', $event.target.checked)" />
        <f7-list-item checkbox title="訂單代號改為數字" :checked="storeData.useOrderNumber" @change="setEditorStoreData('useOrderNumber', $event.target.checked)" />
        <f7-list-item checkbox title="使用自助收銀機" :checked="storeData.useCashier" @change="setEditorStoreData('useCashier', $event.target.checked)" />
        <f7-list-item checkbox title="使用自助收銀機印表機" :checked="storeData.usePrinter" @change="setEditorStoreData('usePrinter', $event.target.checked)" />
        <f7-list-item checkbox title="使用自助收銀機第二印表機" :checked="storeData.useSecondaryPrinter" @change="setEditorStoreData('useSecondaryPrinter', $event.target.checked)" />
        <f7-list-item checkbox title="使用叫號螢幕" :checked="storeData.useMonitor" @change="setEditorStoreData('useMonitor', $event.target.checked)" />
        <f7-list-item radio value="true" name="use-receipt" :checked="storeData.useReceipt" title="開立發票" @change="setEditorStoreData('useReceipt', $event.target.value === 'true')" />
        <f7-list-item radio value="false" name="use-receipt" :checked="!storeData.useReceipt" title="開立收據" @change="setEditorStoreData('useReceipt', $event.target.value === 'true')" />
        <f7-list-item checkbox title="使用政府補助案" :checked="storeData.useBizlion" @change="setEditorStoreData('useBizlion', $event.target.checked)" />
        <f7-list-item ref="bizlionApiKey">
          <f7-label>政府補助案金鑰</f7-label>
          <f7-input type="text" placeholder="ex. 1GTfKGVv26R" :value="storeData.bizlionApiKey" @input="setEditorStoreData('bizlionApiKey', $event.target.value)" @focus="onFocus('bizlionApiKey')" clear-button />
        </f7-list-item>

        <f7-list-item title="電子發票設定 (上方須選擇「使用自助收銀機」、「開立發票」)" group-title />
        <f7-list-item ref="invoiceClientId">
          <f7-label>電子發票客戶代號</f7-label>
          <f7-input type="text" placeholder="ex. 4aeeb264-e5eb-4d7f-d45b-42d5761d8d30" :value="storeData.invoiceClientId" @input="setEditorStoreData('invoiceClientId', $event.target.value)" @focus="onFocus('invoiceClientId')" clear-button />
        </f7-list-item>
        <f7-list-item ref="minInvoiceNumberStored">
          <f7-label>本機號碼少於幾張要下載字軌 (建議設為每日預計用量)</f7-label>
          <f7-input type="text" placeholder="ex. 500" :value="storeData.minInvoiceNumberStored" @input="setEditorStoreData('minInvoiceNumberStored', $event.target.value)" @focus="onFocus('minInvoiceNumberStored')" clear-button />
        </f7-list-item>
        <f7-list-item ref="invoiceBookletToBookOnce">
          <f7-label>每次不足時下載卷數 (一卷 50 張)</f7-label>
          <f7-input type="text" placeholder="ex. 3" :value="storeData.invoiceBookletToBookOnce" @input="setEditorStoreData('invoiceBookletToBookOnce', $event.target.value)" @focus="onFocus('invoiceBookletToBookOnce')" clear-button />
        </f7-list-item>
        <f7-list-item
          v-for="(variation, index) in menuVariations"
          :key="`store-info-settings-menu-variations-${index}`"
          checkbox
          :title="`菜單：「${variation.variationTitle}」使用系統電子發票`"
          :checked="storeData.menuReceiptSetting[variation.variation] ? storeData.menuReceiptSetting[variation.variation].useReceipt : false"
          @change="setMenuReceiptSetting(variation.variation, $event.target.checked)" />

        <f7-list-item title="手續費 (用於報表呈現)" group-title />
        <f7-list-item ref="creditCardProcessingFee">
          <f7-label>信用卡手續費 (%)</f7-label>
          <f7-input type="number" placeholder="ex. 2" :value="storeData.creditCardProcessingFee" @input="setEditorStoreData('creditCardProcessingFee', parseFloat($event.target.value))" @focus="onFocus('creditCardProcessingFee')" clear-button />
        </f7-list-item>
        <f7-list-item ref="easyCardProcessingFee">
          <f7-label>悠遊卡手續費 (%)</f7-label>
          <f7-input type="number" placeholder="ex. 1.5" :value="storeData.easyCardProcessingFee" @input="setEditorStoreData('easyCardProcessingFee', parseFloat($event.target.value))" @focus="onFocus('easyCardProcessingFee')" clear-button />
        </f7-list-item>
        <f7-list-item ref="linePayProcessingFee">
          <f7-label>LINE Pay 手續費 (%)</f7-label>
          <f7-input type="number" placeholder="ex. 3" :value="storeData.linePayProcessingFee" @input="setEditorStoreData('linePayProcessingFee', parseFloat($event.target.value))" @focus="onFocus('linePayProcessingFee')" clear-button />
        </f7-list-item>

        <f7-list-item title="付款方式設定" group-title />
        <f7-list-item checkbox title="接受悠遊卡付款" :checked="storeData.acceptEasyCard" @change="onSetPaymentMethod('acceptEasyCard', $event.target.checked)" />
        <f7-list-item v-if="storeData.acceptEasyCard && storeData.payDiscount" style="padding-right: 0px">
          <discount-option
            paymentMethod="acceptEasyCard"
            :discount="(storeData.payDiscount && storeData.payDiscount.acceptEasyCard) ? storeData.payDiscount['acceptEasyCard'] : 0"
            @onDiscountPropertiesChanged="setDiscountProperties"
          ></discount-option>
        </f7-list-item>
        <f7-list-item checkbox title="接受信用卡付款" :checked="storeData.acceptCreditCard" @change="onSetPaymentMethod('acceptCreditCard', $event.target.checked)" />
        <f7-list-item v-if="storeData.acceptCreditCard && storeData.payDiscount" >
          <discount-option
            paymentMethod="acceptCreditCard"
            :discount="(storeData.payDiscount && storeData.payDiscount.acceptCreditCard) ? storeData.payDiscount['acceptCreditCard'] : 0"
            @onDiscountPropertiesChanged="setDiscountProperties"
          ></discount-option>
        </f7-list-item>
        <f7-list-item checkbox title="接受線上 LINE Pay 付款" :checked="storeData.acceptLinePayOnline" @change="onSetPaymentMethod('acceptLinePayOnline', $event.target.checked)" />
        <f7-list-item ref="linePayChannelId">
          <f7-label>LINE Pay 商家通路 ID</f7-label>
          <f7-input type="text" placeholder="ex. 1608941332" :value="storeData.linePayChannelId" @input="setEditorStoreData('linePayChannelId', $event.target.value)" @focus="onFocus('linePayChannelId')" clear-button />
        </f7-list-item>
        <f7-list-item ref="linePayChannelSecretKey">
          <f7-label>LINE Pay 商家通路密鑰</f7-label>
          <f7-input type="text" placeholder="ex. 0ad32b31b1fa28dadb8cc5cf5b839652" :value="storeData.linePayChannelSecretKey" @input="setEditorStoreData('linePayChannelSecretKey', $event.target.value)" @focus="onFocus('linePayChannelSecretKey')" clear-button />
        </f7-list-item>
        <f7-list-item v-if="storeData.acceptLinePayOnline && storeData.payDiscount">
          <discount-option
            paymentMethod="acceptLinePayOnline"
            :discount="(storeData.payDiscount && storeData.payDiscount.acceptLinePayOnline) ? storeData.payDiscount['acceptLinePayOnline'] : 0"
            @onDiscountPropertiesChanged="setDiscountProperties"
          ></discount-option>
        </f7-list-item>
         <f7-list-item checkbox title="接受街口支付付款" :checked="storeData.acceptJkos" @change="onSetPaymentMethod('acceptJkos', $event.target.checked)" />
         <f7-list-item v-if="storeData.acceptJkos && storeData.payDiscount">
          <discount-option
            paymentMethod="acceptJkos"
            :discount="(storeData.payDiscount && storeData.payDiscount.acceptJkos) ? storeData.payDiscount['acceptJkos'] : 0"
            @onDiscountPropertiesChanged="setDiscountProperties"
          ></discount-option>
        </f7-list-item>
        <f7-list-item checkbox title="接受現金付款" :checked="storeData.acceptCash" @change="onSetPaymentMethod('acceptCash', $event.target.checked)" />
        <f7-list-item v-if="storeData.acceptCash && storeData.payDiscount">
          <discount-option
            paymentMethod="acceptCash"
            :discount="(storeData.payDiscount && storeData.payDiscount.acceptCash) ? storeData.payDiscount['acceptCash'] : 0"
            @onDiscountPropertiesChanged="setDiscountProperties"
          ></discount-option>
        </f7-list-item>
        <f7-list-item checkbox title="接受其他付款方式" :checked="storeData.acceptOthers" @change="onSetPaymentMethod('acceptOthers', $event.target.checked)" />
        <f7-list-item v-if="storeData.acceptOthers && storeData.payDiscount">
          <discount-option
            paymentMethod="acceptOthers"
            :discount="(storeData.payDiscount && storeData.payDiscount.acceptOthers) ? storeData.payDiscount['acceptOthers'] : 0"
            @onDiscountPropertiesChanged="setDiscountProperties"
          ></discount-option>
        </f7-list-item>
      </f7-list>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Vue from 'vue'
import * as R from 'ramda'
import { storeClient } from '@/service/apiClients'
import storeSettingHelp from '@Util/store/storeSettingHelp'
import DiscountOption from '../components/store-info-setting/DiscountOption'

export default {
  data () {
    return {
      storeData: null,
      edittedTableNumbers: null
    }
  },
  watch: {
    store (store) {
      if (store) {
        Vue.set(this, 'storeData', Object.assign({}, store))
      }
    }
  },
  async created () {
    await this.setStore(this.storeIdProp)
    await this.asyncStoreData()
    this.getMenuVariations()
  },
  props: {
    storeIdProp: String
  },
  computed: {
    ...mapState(['store']),
    ...mapState('menuModule', ['menuVariations']),
    dirty () {
      return !R.equals(this.store, this.storeData)
    }
  },
  methods: {
    ...mapActions(['setStore', 'setStoreData', 'getTableNumbers', 'asyncStoreData']),
    ...mapActions('menuModule', ['getMenuVariations']),
    reset () {
      Vue.set(this, 'storeData', Object.assign({}, this.store))
      this.getMenuVariations()
    },
    onSetPaymentMethod (method, checked) {
      this.setEditorStoreData(method, checked)
      this.setEditorStoreData('payDiscount', storeSettingHelp.setPaymentDiscountInfo(this.storeData, method, checked, 0))
    },
    setDiscountProperties (paymentMethod, discount) { // 給 discount-option 呼叫，接收折扣的資料
      this.setEditorStoreData('payDiscount', storeSettingHelp.setPaymentDiscountInfo(this.storeData, paymentMethod, true, discount))
    },
    setMenuReceiptSetting (variation, useReceipt) {
      this.setEditorStoreData('menuReceiptSetting', storeSettingHelp.setMenuReceiptSetting(this.storeData, variation, useReceipt))
    },
    onServiceChargeBlur () {
      if (!this.storeData.serviceCharge || this.storeData.serviceCharge < 0) {
        Vue.set(this.storeData, 'serviceCharge', 0)
      }
    },
    async save () {
      if (this.isValid()) {
        try {
          const { data: newStore } = await storeClient.put(`/stores/${this.storeIdProp}`, this.storeData)
          // TODO: newStore 還有問題，paymentMethods 還沒有放進去
          if (this.storeIdProp === newStore.id) {
            await this.asyncStoreData()
            await this.getMenuVariations()
            // this.setStoreData(newStore)
          } else {
            this.$f7router.navigate(`/stores/${newStore.id}/store-info-settings`, {
              reloadCurrent: true
            })
          }
        } catch (e) {
          this.$f7.dialog.alert('餐廳資訊更新失敗', '更新失敗')
        }
      } else {
        this.$f7.dialog.alert('請檢查表單是否正確', '表單未完成')
      }
    },
    onFocus (field) {
      this.$refs[field].$el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    },
    isValid () {
      return this.storeData.id &&
        this.storeData.name &&
        this.storeData.phoneNumber &&
        this.storeData.registeredOwner &&
        this.storeData.email &&
        this.storeData.preOrderDisplayBoundaryMinutes
    },
    requiredStyle (field) {
      return { color: this.storeData[field] ? 'rgba(0, 0, 0, 0.65)' : 'red' }
    },
    setEditorStoreData (field, value) {
      Vue.set(this.storeData, field, value)
    }
  },
  components: {
    DiscountOption
  }
}
</script>

<style lang="scss" scoped>
.dirty {
  animation: blink 1s ease-in-out infinite alternate;
}

@keyframes blink {
  from { color: white; }
  to {
    color: #FFAAAA;
    transform: scale(1.2);
  }
}
</style>
